var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cartCrossSell.length
    ? _c("div", { staticClass: "cart-cross-sell" }, [
        _vm.isLoggedIn
          ? _c("h2", {
              staticClass: "cart-cross-sell__title",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("cart.crossSell.titleLoggedIn", {
                    name: this.accountUserDetail.firstName,
                  })
                ),
              },
            })
          : _c("h2", {
              staticClass: "cart-cross-sell__title",
              domProps: { innerHTML: _vm._s(_vm.$t("cart.crossSell.title")) },
            }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cart-cross-sell__products" },
          _vm._l(_vm.productsEnhanced, function (product, index) {
            return _c("ShoplistProduct", {
              key: product.code,
              attrs: {
                product: product,
                locked: _vm.lockedProducts[product.code],
              },
              on: {
                addToCart: _vm.onAddToCart,
                config: _vm.onConfig,
                click: _vm.onClickProduct,
              },
            })
          }),
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }